var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isIE)?_c('div',{staticClass:"app-disclaimer"},[_c('span',{staticClass:"app-disclaimer__bg"}),_c('p',{staticClass:"app-disclaimer__content",domProps:{"innerHTML":_vm._s(_vm.$translate('layout').disclaimer)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }